import { TableService as TableServiceBase } from 'prime-ng-old/table';
import * as i0 from "@angular/core";
export let TableService = /*#__PURE__*/(() => {
  class TableService extends TableServiceBase {
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵTableService_BaseFactory;
        return function TableService_Factory(__ngFactoryType__) {
          return (ɵTableService_BaseFactory || (ɵTableService_BaseFactory = i0.ɵɵgetInheritedFactory(TableService)))(__ngFactoryType__ || TableService);
        };
      })();
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: TableService,
        factory: TableService.ɵfac
      });
    }
  }
  return TableService;
})();